import { defineMessages } from "react-intl";

import { validator } from "lib/build/forms/htx/lab-procedures/ntProBnp";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	ntProBNP: {
		id: "form.nt_pro_bnp",
		defaultMessage: "NT-proBNP"
	},
	value: {
		id: "form.nt_pro_bnp.value",
		defaultMessage: "Érték"
	}
});

const fields: { [key: string]: FieldData } = {
	value: {
		type: "field",
		path: ["value"],
		label: messages.value,
		errorMessages: genericErrorMessages,
		input: { type: "input", props: { type: "number" } }
	}
};

const fieldset: FieldsetData = {
	rows: [{ columns: [{ width: 12, field: fields.value }] }]
};

export const node: LeafNode = {
	id: "ntProBNP",
	value: {
		schemaId: "ntProBnp",
		title: messages.ntProBNP,
		validator,
		fieldset,
		isImportant: true
	}
};
